export default __webpack_public_path__ + "static/media/Component55–1.8b4f8cd2.svg";